import {
  ConnectBulkPayload,
  ConnectStudentBulkPayload,
  Filters,
  OrganizationUserResponse,
} from "../../../types"
import { getApiClient } from "../../client"

interface OrganizationUserApiConfig {
  baseEndpoint: string
}

export function createOrganizationUserService(
  config: OrganizationUserApiConfig,
) {
  const { baseEndpoint } = config

  return {
    async list(filters?: Filters) {
      const apiClient = getApiClient()

      return await apiClient
        .post<OrganizationUserResponse>(`${baseEndpoint}`, {
          json: filters,
        })
        .json()
    },

    async connectBulk(payload: ConnectBulkPayload) {
      const apiClient = getApiClient()

      return await apiClient
        .post(`${baseEndpoint}/connect/bulk`, {
          json: payload,
        })
        .json()
    },

    async connectStudentBulk(payload: ConnectStudentBulkPayload) {
      const apiClient = getApiClient()

      return await apiClient
        .post(`${baseEndpoint}/students/connect/bulk`, {
          json: payload,
        })
        .json()
    },
  }
}

export function buildConnectStudentBulkPayload(
  studentId: number,
  customerManagerIds: number[],
): ConnectStudentBulkPayload {
  return {
    studentId,
    customerManagerIds,
  }
}

export function buildConnectPayload(
  userId: number,
  studentIds: number[],
): ConnectBulkPayload {
  return {
    customerManagers: [
      {
        customerManagerId: userId,
        studentIds,
      },
    ],
  }
}
